import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Description from "../../../components/ui/Description";
import TitleStyles from "../../../components/ui/TitleStyles";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import { Container, Position } from "./MusicSetsyStyles";
import InputLinkGroup from "../../../components/inputLinkGroup/InputLinkGroup";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import { usePressKit } from "../../../context/PressKitContext";

const MusicSets = () => {
  const navigate = useNavigate();
  const { setPressKitData } = usePressKit();

  const [tracks, setTracks] = useState<{ name: string; url: string }[]>([]);

  const handleChange = (items: { name: string; url: string }[]) => {
    setTracks(items);
    setPressKitData((prev) => ({ ...prev, musicLinks: items }));
  };

  return (
    <Container>
      <TitleStyles>Músicas e Sets</TitleStyles>
      <Description>Adicione os links:</Description>

      <InputLinkGroup
        nameLabel="Nome"
        namePlaceholder="Nome da música ou set"
        urlLabel="Link"
        urlPlaceholder="https://www.link.com"
        onChange={handleChange}
        previewEnabled={true}
        initialItems={[{ name: "", url: "" }]}
      />

      <Position>
        <ProgressBar totalSteps={9} currentStep={1} />
        <ButtonGroup
          onBack={() => navigate("/biography")}
          onNext={() => navigate("/events")}
        />
      </Position>
    </Container>
  );
};

export default MusicSets;
